/**
 * Нужно ли перезагрузить админку из‑за новой сборки на сервере.
 * @param currentBuildId — buildId, запомненный при открытии вкладки
 * @param remoteBuildId — buildId из /version.json
 */
export const shouldReloadForNewAdminBuild = (
  currentBuildId: string | null | undefined,
  remoteBuildId: string | null | undefined
): boolean => {
  if (!currentBuildId || !remoteBuildId) {
    return false
  }
  return currentBuildId !== remoteBuildId
}
